import { colors, typography, effects } from "../../../design/tokens";
import { useSubscriptionsModal } from "../../../providers/SubscriptionsModalProvider";

export default function ProjectOutOfTokensMessage() {
  const { open: openSubscriptionsModal } = useSubscriptionsModal();

  return (
    <div className={`border ${effects.borderRadius.xl} border-dark-border p-6`}>
      <div className="flex flex-col items-center gap-6">
        <div
          className={`flex flex-col gap-2 ${typography.size.base} ${colors.text.primary} leading-[1.6] text-center`}
        >
          <p>
            You've run out of tokens. Wait for your monthly reset or upgrade
            your plan to continue.
          </p>
        </div>
        <div className="flex justify-center w-full max-w-[200px]">
          <button
            className={`w-full flex items-center justify-center
              py-2 bg-primary-blue
              ${colors.hover.brightness} hover:cursor-pointer
              ${effects.transition.default} ${effects.borderRadius.md}
              ${typography.size.sm} text-white`}
            onClick={openSubscriptionsModal}
          >
            Upgrade plan
          </button>
        </div>
      </div>
    </div>
  );
}
